import { Injectable } from '@angular/core';
import { MOI } from '../enums/moi.enum';
import { TranslateService } from '@ngx-translate/core';
import { BiggerPictureMessagesService } from './bigger-picture-messages.service';
import { SystemMessagesEnum } from '../enums/system-messages.enum';
import { AppInjector } from './app-injector.service';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseService {
  moi = MOI;
  systemMessagesEnum = SystemMessagesEnum;
  protected translate: TranslateService;
  protected biggerPictureMessagesService: BiggerPictureMessagesService;

  protected constructor() {
    AppInjector.getInjector().subscribe((injector) => {
      this.translate = injector.get(TranslateService);
      this.biggerPictureMessagesService = injector.get(BiggerPictureMessagesService);
    });

  }

  tranKey(moi: MOI, msgId: number, type = 'text'): string {
    return this.biggerPictureMessagesService.tranKey(moi, msgId, type);
  }
}

